const userInfo = {
  data() {
    return {}
  },
  computed: {
    user() {
      if(this.$store.state.user !== '' && typeof this.$store.state.user === 'string') {
        return JSON.parse(this.$store.state.user)
      } else {
        return this.$store.state.user
      }
    },
    user_key() {
      return this.$store.state.user_key
    },
    isVIP() {
      if(this.user) {
        return this.user.db_vip == '1' || this.user.vip == '1'
      } else {
        return false
      }
    }
  }
}
export { userInfo }
